
import React, { Component } from "react";
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

import { observer, inject } from "mobx-react";
import {  Link } from "react-router-dom";

import UserService from "../service/UserService";
import Routes from "./Routes";


moment.locale('en');
momentLocalizer();

@inject("dataStore")
@inject("postStore")
@inject("videoStore")
//@inject("forms")
@observer
export default class App extends Component {
    state = {};

    render() {
        let user = this.props.dataStore.user;

        return (
            <div>
               
                <div className="header">
                    <div className="App-logo"> <Link to="/"><img src={require("../assets/images/header-logo.png")} title="Inside By Powerfront" alt="Inside By Powerfront" /></Link></div>

                    <div className="login">{(!this.props.dataStore.isLoggedIn) ? <Link className="login-link" to="/login"><button type="button" >Login</button></Link> : <div className="userinfo"> <button onClick={e => UserService.signout(user)} >Logout</button><div className="userinfoname">{user.displayName}</div></div> }</div>
                   
                </div>
                <Routes {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.jsx